var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRapprochements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19.625,
    viewBox: "0 0 23 19.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_core-balance-scale",
    "data-name": "Icon core-balance-scale",
    transform: "translate(-0.5 -3.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35807",
    "data-name": "Path 35807",
    d: "M9.527,18.113l.223-.245V16.659L6.1,8.953H4.4L.75,16.659v1.268l.2.215a5.829,5.829,0,0,0,4.276,1.874h.02a5.829,5.829,0,0,0,4.283-1.9ZM8.25,17.278a4.262,4.262,0,0,1-3.011,1.238H5.224A4.261,4.261,0,0,1,2.25,17.328V17l3-6.333L8.25,17ZM19.6,8.953H17.9l-3.65,7.706v1.268l.2.215a5.829,5.829,0,0,0,4.276,1.874h.02a5.829,5.829,0,0,0,4.283-1.9l.223-.245V16.659Zm2.15,8.325a4.262,4.262,0,0,1-3.011,1.238h-.015a4.261,4.261,0,0,1-2.974-1.188V17l3-6.333,3,6.333Z",
    fill: "#027bc7",
    stroke: "#027bc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35808",
    "data-name": "Path 35808",
    d: "M12.75,9.218a2.635,2.635,0,0,0,1.765-1.765H19.5v-1.5H14.515a2.625,2.625,0,0,0-5.031,0H4.5v1.5H9.485A2.635,2.635,0,0,0,11.25,9.218V21.7H6.375v1.5h11.25V21.7H12.75ZM10.875,6.7A1.125,1.125,0,1,1,12,7.828,1.125,1.125,0,0,1,10.875,6.7Z",
    fill: "#027bc7",
    stroke: "#027bc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapprochements);
export default __webpack_public_path__ + "static/media/rapprochements.7efcc64a28e9e0ba052d30d40465b261.svg";
export { ForwardRef as ReactComponent };